import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '/api';
const COOKIE_MODE = String(process.env.REACT_APP_COOKIE_AUTH || '').toLowerCase() === 'true';

// Create axios instance with base URL
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// When using HttpOnly cookie auth, allow browser to send cookies
if (COOKIE_MODE) {
  api.defaults.withCredentials = true;
}

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 